<!--
 * @Author: xuquantong
 * @Date: 2023-09-28 14:34:16
 * @LastEditors: xuquantong
 * @LastEditTime: 2023-10-18 14:17:17
 * @Description: 通用的推荐商品列表，和/components/recommend有细微差别，除了支付成功页使用/components/recommend之外，都使用这个组件
-->
<template>
  <div class="recommend-container">
    <div class="product-list">
      <a
        v-for="item in list"
        :key="item.id"
        :href="item.url"
        class="item"
        v-track="[
          {
            act: 'show',
            params: {
              event_id: '101|013|02|077',
              sku_id: item.id
            }
          },
          {
            act: 'click',
            params: {
              event_id: '101|013|01|077',
              sku_id: item.id
            }
          }
        ]"
      >
        <img v-lazy="item.imgUrl" alt="" />
        <p class="name border1px">{{ item.name }}</p>
        <div class="price">
          <span class="yen">¥</span>
          <span>{{ item.salePrice | formatNumber }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import create from '../create'
import fetch from '@/api/fetch'

export default create({
  name: 'recommendlist',
  data() {
    return {
      list: []
    }
  },
  async created() {
    const data = await fetch({
      url: '/recommend/list',
      method: 'post'
    })
    if (data && data.length) {
      this.list = data
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
